import React from "react"
import { ThumborConfiguration } from "react-thumbor-img"

type ConfigProps = {
    env?: { [key: string]: string | undefined }
}

const ThumborConfigured: React.FC<ConfigProps> = ({ children, env }) => {
    env = env || process.env
    if (env.NODE_ENV == "production" && !env.GATSBY_ORIGIN) throw new Error("GATSBY_ORIGIN is not defined.")
    const relativeImgPolicy =
        env.NODE_ENV == "production"
            ? ({ name: "prependOrigin", origin: env.GATSBY_ORIGIN as string } as const)
            : ({ name: "passThrough" } as const)
    return (
        <ThumborConfiguration relativeImgPolicy={relativeImgPolicy} server="https://img.yta.se">
            {children}
        </ThumborConfiguration>
    )
}

export { ThumborConfigured }
